import React from 'react';
import { Plus, Minus } from 'lucide-react';

interface MeasurementAdjusterProps {
  value: number;
  onChange: (value: number) => void;
  label?: string;
  // Без подписи — когда название замера выводится рядом (строка с галочкой)
  hideLabel?: boolean;
  step?: number;
  min?: number;
  max?: number;
  disabled?: boolean;
}

const MeasurementAdjuster: React.FC<MeasurementAdjusterProps> = ({
  value,
  onChange,
  label,
  hideLabel = false,
  step = 0.5,
  min = -999,
  max = 999,
  disabled = false
}) => {
  const handleIncrease = () => {
    const newValue = value + step;
    onChange(newValue);
  };

  const handleDecrease = () => {
    const newValue = value - step;
    onChange(newValue);
  };

  const isDecreaseDisabled = disabled;

  return (
    <div className={hideLabel ? '' : 'mb-2'}>
      {!hideLabel && <label className="block text-sm font-medium text-gray-700 mb-2">{label} (см)</label>}
      <div className="flex items-center space-x-2">
        <button
          type="button"
          onClick={handleDecrease}
          disabled={isDecreaseDisabled}
          className="flex items-center justify-center w-8 h-8 rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
          title={`Уменьшить на ${step} см`}
        >
          <Minus size={16} />
        </button>
        
        <input
          type="number"
          value={value}
          onChange={(e) => {
            const inputValue = parseFloat(e.target.value);
            if (!isNaN(inputValue)) {
              onChange(inputValue);
            }
          }}
          onFocus={(e) => {
            e.target.select();
          }}
          step={step}
          disabled={disabled}
          className="w-20 px-2 py-2 text-center border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
        />
        
        <button
          type="button"
          onClick={handleIncrease}
          disabled={disabled}
          className="flex items-center justify-center w-8 h-8 rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
          title={`Увеличить на ${step} см`}
        >
          <Plus size={16} />
        </button>
      </div>
    </div>
  );
};

export default MeasurementAdjuster; 